let language = {

    "STORE_EMAIL_SETTING_FAIL_TO_RETRIEVE_EMAIL_SETTING_TITLE": "无法获取商店邮箱设置",
    // 当前用户与storeId不匹配
    "A121B001": "当前用户与商店不匹配。",
    
    "STORE_EMAIL_SETTING_FAIL_SEND_EMAIL_TITLE": "发送邮件失败",
    // 连接失败
    "A121B002": "SMTP 服务器连接失败，请检查您的 SMTP 服务器配置后重试。",
    // 授权错误
    "A121B003": "服务器授权失败，请检查您的邮箱地址或密码确保其正确。",
    // 发送失败
    "A121B004": "SMTP 服务器发送邮件失败",

};

export { language }
